const settings = {
  className: 'slickMainRates',
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'linear',
  pauseOnHover: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 9999,
      settings: 'unslick',
    },
    {
      breakpoint: 767,
      settings: {
        dots: false,
      },
    },
  ],
};

export default settings;
